var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal-dialog modal-small", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("message.getnotificationsvialine")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "section",
              [
                _c("stepprogress-view", {
                  staticClass: "pt-2 stepprogress",
                  staticStyle: { "max-width": "100%", margin: "auto" },
                  attrs: {
                    steps: _vm.progress.steps,
                    active: _vm.progress.active
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm.line_step_state == 1
              ? _c("section", { staticClass: "m-0" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-title", {
                        attrs: {
                          title: _vm.$t("message.connecttoline"),
                          fontweight: "bold"
                        }
                      }),
                      _vm._v(" "),
                      _vm.connect_with_line_error
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "alert alert-danger mb-2",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("message.somethingwentwrong")
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.is_exitst_channel
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "alert alert-danger mb-2",
                                  attrs: { role: "alert" }
                                },
                                [
                                  _vm._v(
                                    '\n                  "' +
                                      _vm._s(this.form.auth.displayname) +
                                      '"\n                  ' +
                                      _vm._s(
                                        _vm.$t(
                                          "message.hasbeenaddedtothenotificationlist"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isConnectedLine
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-web btn-line",
                                  staticStyle: { with: "100px" },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.login()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("message.loginwithline")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isConnectedLine
                        ? _c("div", { staticClass: "row mt-3" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12 text-center" },
                              [
                                _vm.form.auth.picture
                                  ? _c("img", {
                                      staticStyle: { "border-radius": "100%" },
                                      attrs: {
                                        src: _vm.form.auth.picture,
                                        width: "100"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", { staticClass: "mt-3" }, [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.form.auth.displayname))
                                  ])
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding mt-3" },
                    [
                      _c("section-title", {
                        attrs: {
                          title: _vm.$t("message.getnotititle"),
                          fontweight: "bold"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.code, function(value, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "col-12 mt-2" },
                            [
                              _c(
                                "vs-checkbox",
                                {
                                  staticStyle: { float: "left", margin: "0" },
                                  attrs: { vsValue: value, color: "#A3CA76" },
                                  model: {
                                    value: _vm.form.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "code", $$v)
                                    },
                                    expression: "form.code"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("notificationcode." + value)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-tooltip",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "5px"
                                  },
                                  attrs: {
                                    text: _vm.$t(
                                      "notificationcodedetail." + value
                                    ),
                                    position: "top"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-info-circle" })]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.line_step_state == 2
              ? _c("section", { staticClass: "m-0" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding text-center" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("message.scanqrcodeoraddwithlineid")
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              float: "left",
                              width: "466px",
                              "margin-top": "13px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  position: "relative",
                                  float: "left",
                                  width: "95px",
                                  left: "185.5px"
                                }
                              },
                              [
                                _c("iframe", {
                                  staticStyle: {
                                    width: "95px",
                                    height: "20px",
                                    visibility: "visible",
                                    position: "static !important",
                                    opacity: "1 !important",
                                    border: "none"
                                  },
                                  attrs: {
                                    src:
                                      "https://social-plugins.line.me/widget/friend?lineId=%40treesoft&lang=" +
                                      _vm.$store.state.app.lang +
                                      "&type=friend&id=0&origin=https%3A%2F%2Fwww.treesoft.io%2Fline.html&title="
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.line_step_state == 3
              ? _c("section", { staticClass: "m-0" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding text-center" },
                    [
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "message.addednotificationreceivedsuccessfully"
                              )
                            ) +
                            "\n            "
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-footer row m-0 pr-0",
              staticStyle: {
                "justify-content": "normal",
                display: "-webkit-box"
              }
            },
            [
              _c(
                "div",
                { staticClass: "row col-12 pr-0 d-flex align-items-center" },
                [
                  _c("div", { staticClass: "col-4 p-0 text-left" }, [
                    _c(
                      "a",
                      { attrs: { href: _vm.learnmoreLink, target: "_blank" } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("button.learnmore")) +
                            "\n              "
                        ),
                        _c("i", { staticClass: "fas fa-external-link-alt" })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-8 p-0 text-right" },
                    [
                      _vm.line_step_state == 1
                        ? [
                            _vm.$store.state.app.loading
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-light",
                                    attrs: { disabled: true, type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toStep2()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-spinner spin"
                                    })
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-light",
                                    attrs: {
                                      disabled:
                                        !_vm.isConnectedLine ||
                                        !_vm.isSelectedNoti,
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toStep2()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("button.next")) +
                                        "\n              "
                                    )
                                  ]
                                )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.line_step_state == 2
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.toStep3()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("button.addedfriend")) +
                                  "\n              (" +
                                  _vm._s(_vm.$t("button.next")) +
                                  ")\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.line_step_state == 3
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-web",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.done()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("button.done")) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.line_step_state == 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: {
                                disabled: _vm.$store.state.app.loading,
                                type: "button"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.closed()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("button.close")) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/qrcode/treesoft.png"),
          width: "150"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbddbee2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbddbee2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/modal/channelnoti/AddLine.vue
// module id = null
// module chunks = 